import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import BubbleChartIcon from '@mui/icons-material/BubbleChart'
import RssFeedIcon from '@mui/icons-material/RssFeed'
import GridViewIcon from '@mui/icons-material/GridView'
import HistoryIcon from '@mui/icons-material/History'
import AdminGuard from './AdminGuard'
import AdminSplashScreen from '../AdminSplashScreen/AdminSplashScreen'
import AtlasTabs from '../../shared/components/Tabs/Tabs'
import OrganizationsTab from './tabs/OrganizationsTab'
import RoadmapAnalyticsTab from './tabs/RoadmapAnalyticsTab'
import ActivityFeedTab from './tabs/ActivityFeedTab'
import FeatureAdoptionTab from './tabs/FeatureAdoptionTab'
import AdminAuditLogsTab from './tabs/AdminAuditLogsTab'

const TAB_IDS = ['organizations', 'analytics', 'activity', 'adoption', 'audit']

const AdminPanel: React.FC = () => {
    const location = useLocation()
    const [selectedTabId, setSelectedTabId] = useState('organizations')
    const [showSplash, setShowSplash] = useState(true)

    // Restore tab when navigating back (location state uses legacy numeric index)
    useEffect(() => {
        // @ts-ignore - custom location state property
        const autoOpenData = location.autoOpenData
        const navData = autoOpenData?.autoOpenData || autoOpenData?.data
        if (navData?.tabIndex !== undefined) {
            setSelectedTabId(TAB_IDS[navData.tabIndex] || 'organizations')
        }
    }, [location])

    return (
        <AdminGuard>
            <AdminSplashScreen
                isVisible={showSplash}
                onClose={() => setShowSplash(false)}
                getIsRecentlyLoggedIn={() => false}
            />
            <Box sx={{ p: 3, minHeight: '100vh', visibility: showSplash ? 'hidden' : 'visible' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <AdminPanelSettingsIcon sx={{ fontSize: 28 }} />
                        <Typography variant="h5" component="h1">
                            Admin Panel
                        </Typography>
                    </Box>
                </Box>

                <AtlasTabs
                    orientation="horizontal"
                    selectedTabId={selectedTabId}
                    onTabChange={setSelectedTabId}
                    tabPanelSx={{ pt: 2 }}
                    tabs={[
                        {
                            id: 'organizations',
                            label: 'Organizations',
                            view: <OrganizationsTab />,
                        },
                        {
                            id: 'analytics',
                            label: (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <BubbleChartIcon fontSize="small" />
                                    Analytics
                                </Box>
                            ),
                            view: <RoadmapAnalyticsTab />,
                        },
                        {
                            id: 'activity',
                            label: (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <RssFeedIcon fontSize="small" />
                                    Activity Feed
                                </Box>
                            ),
                            view: <ActivityFeedTab />,
                        },
                        {
                            id: 'adoption',
                            label: (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <GridViewIcon fontSize="small" />
                                    Feature Adoption
                                </Box>
                            ),
                            view: <FeatureAdoptionTab />,
                        },
                        {
                            id: 'audit',
                            label: (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <HistoryIcon fontSize="small" />
                                    Audit Logs
                                </Box>
                            ),
                            view: <AdminAuditLogsTab />,
                        },
                    ]}
                />
            </Box>
        </AdminGuard>
    )
}

export default AdminPanel
